import React from 'react';
import { FormControl, InputLabel, MenuItem } from 'components/ui';
import { SelectFullWidth } from 'components/styles_components/select';
import { FormattedMessage } from 'react-intl';
import Permission from 'utils/permission';

const RoleSelect = (field) => {
  return (
    <FormControl fullWidth margin={field.margin}>
      <InputLabel id={field.name}>{field.label}</InputLabel>
      <SelectFullWidth
        name={field.name}
        id={field.id}
        label={field.label}
        labelId={`${field.name}-label`}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        error={field.error}
      >
        <MenuItem value={Permission().VIEWER}>
          <FormattedMessage id="user.role.viewer" />
        </MenuItem>
        <MenuItem value={Permission().ADMIN}>
          <FormattedMessage id="user.role.admin" />
        </MenuItem>
      </SelectFullWidth>
    </FormControl>
  );
};

export default RoleSelect;
